import { createContext } from "react";
import type { AuthContextType } from "@/hooks/auth/types";

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
